import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';

const state = {
    id_reporte: null,
    archivos: [],
    citas: [],
    tareas: [],
    notas: [],
    negocios: [],
    actividades: []
};

const mutations = {
    updateField,
    updateSidebar: (state, payload) => {
        const { _id, acciones, archivos } = payload;
        state.id_reporte = _id;
        const citas = _.filter(acciones, (accion) => {
            return accion.tipo_accion == 'cita';
        });
        const tareas = _.filter(acciones, (accion) => {
            return accion.tipo_accion == 'tarea';
        });
        const notas = _.filter(acciones, { tipo_accion: "nota" });
        state.citas = citas;
        state.tareas = tareas;
        state.notas = notas;
        state.archivos = archivos;
    },
    addCitaSidebar: (state, payload) => {
        state.citas.push(payload);
    },
    addTareaSidebar: (state, payload) => {
        state.tareas.push(payload);
    }
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    getters
}
